import { combineReducers } from 'redux';

import {
  CHANGE_PAGE,
  // MARKET REPORTS
  FETCH_MARKET_REPORTS_REQUEST,
  FETCH_MARKET_REPORTS_SUCCESS,
  FETCH_MARKET_REPORTS_FAILURE,
  // RESEARCH LIBRARY
  FETCH_REPORTS_FAILURE,
  FETCH_REPORTS_REQUEST,
  FETCH_REPORTS_SUCCESS,
  CHANGE_RESEARCH_LIBRARY_FILTERS,
  CHANGE_TICKERS,
  // CUSTOM EXPORTS
  FETCH_CUSTOM_EXPORTS_REQUEST,
  FETCH_CUSTOM_EXPORTS_SUCCESS,
  FETCH_CUSTOM_EXPORTS_FAILURE,
  UPDATE_CUSTOM_EXPORTS_REQUEST,
  UPDATE_CUSTOM_EXPORTS_SUCCESS,
  UPDATE_CUSTOM_EXPORTS_FAILURE,
  CHANGE_SELECTION,
  CHANGE_CUSTOM_EXPORTS_PER_PAGE,
  // CUSTOM REPORTS
  FETCH_CUSTOM_REPORTS_REQUEST,
  FETCH_CUSTOM_REPORTS_SUCCESS,
  FETCH_CUSTOM_REPORTS_FAILURE,
  FETCH_VERSIONS_REQUEST,
  FETCH_VERSIONS_SUCCESS,
  FETCH_VERSIONS_FAILURE,
  CHANGE_CUSTOM_REPORTS_PER_PAGE,
  // KPI FORECASTS
  FETCH_KPI_FORECASTS_REQUEST,
  FETCH_KPI_FORECASTS_SUCCESS,
  FETCH_KPI_FORECASTS_FAILURE,
  // CURRENT FORECASTS
  FETCH_CURRENT_KPI_FORECAST_REQUEST,
  FETCH_CURRENT_KPI_FORECAST_SUCCESS,
  FETCH_CURRENT_KPI_FORECAST_FAILURE,
  SELECT_KPI_FORECAST,
} from '../actions';

import { defaultState } from '../configs';

const currentPage = (state = defaultState.currentPage, action) => {
  switch (action.type) {
    case CHANGE_PAGE:
      return action.currentPage;
    default:
      return state;
  }
};

const marketReports = (state = defaultState.marketReports, action) => {
  switch (action.type) {
    case FETCH_MARKET_REPORTS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: true,
          error: false,
        },
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    case FETCH_MARKET_REPORTS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
        },
        filters: {
          ...state.filters,
          ...action.filters,
        },
        data: action.data,
      };
    case FETCH_MARKET_REPORTS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
          error: true,
        },
        filters: action.filters,
      };
    default:
      return state;
  }
};

const researchLibrary = (state = defaultState.researchLibrary, action) => {
  switch (action.type) {
    case FETCH_REPORTS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: false,
          pending: true,
        },
      };
    case FETCH_REPORTS_SUCCESS:
      return {
        ...state,
        data: action.data,
        tickers: action.tickers,
        filters: action.filters,
        settings: {
          ...state.settings,
          pending: false,
        },
      };
    case FETCH_REPORTS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: true,
          pending: false,
        },
      };
    case CHANGE_RESEARCH_LIBRARY_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    case CHANGE_TICKERS:
      return {
        ...state,
        tickers: action.tickers,
      };
    default:
      return state;
  }
};

const customExports = (state = defaultState.customExports, action) => {
  switch (action.type) {
    case FETCH_CUSTOM_EXPORTS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: false,
          pending: true,
        },
      };
    case FETCH_CUSTOM_EXPORTS_SUCCESS:
      return {
        ...state,
        data: action.list,
        filters: action.filters,
        settings: {
          ...state.settings,
          pending: false,
        },
      };
    case FETCH_CUSTOM_EXPORTS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: true,
          pending: false,
        },
      };
    case UPDATE_CUSTOM_EXPORTS_REQUEST:
      return {
        ...state,
        data: state.data.map(report => (action.listIds.includes(report.id)
          ? { ...report, state: 'pending' }
          : report)),
      };
    case UPDATE_CUSTOM_EXPORTS_SUCCESS: {
      const newReports = new Map(action.list.map(obj => ([obj.id, obj])));
      return {
        ...state,
        selectedExports: [],
        data: state.data.map(report => (newReports.has(report.id)
          ? { ...report, ...newReports.get(report.id) }
          : report)),
      }; }
    case UPDATE_CUSTOM_EXPORTS_FAILURE:
      return {
        ...state,
        data: state.data.map(report => (action.listIds.includes(report.id) ? { ...report, state: 'processed' } : report)),
      };
    case CHANGE_SELECTION:
      return {
        ...state,
        selectedExports: action.reports,
      };
    case CHANGE_CUSTOM_EXPORTS_PER_PAGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          pagination: {
            ...state.filters.pagination,
            per_page: action.perPage,
          },
        },
      };
    default:
      return state;
  }
};

const customReports = (state = defaultState.customReports, action) => {
  switch (action.type) {
    case FETCH_CUSTOM_REPORTS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: false,
          pending: true,
        },
      };
    case FETCH_CUSTOM_REPORTS_SUCCESS:
      return {
        ...state,
        data: action.data,
        filters: action.filters,
        settings: {
          ...state.settings,
          pending: false,
        },
      };
    case FETCH_CUSTOM_REPORTS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: true,
          pending: false,
        },
      };
    case CHANGE_CUSTOM_REPORTS_PER_PAGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          pagination: {
            ...state.filters.pagination,
            per_page: action.perPage,
            current_page: 0,
          },
        },
      };
    default:
      return state;
  }
};

const versionHistory = (state = defaultState.versionHistory, action) => {
  switch (action.type) {
    case FETCH_VERSIONS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: false,
          pending: true,
        },
      };
    case FETCH_VERSIONS_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data,
          ...action.versionHistory,
        ],
        filters: {
          ...state.data,
          ...action.versionHistory.filters,
        },
        settings: {
          ...state.settings,
          pending: false,
        },
      };
    case FETCH_VERSIONS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          error: true,
          pending: false,
        },
      };
    default:
      return state;
  }
};

const forecasts = (state = defaultState.forecasts, action) => {
  switch (action.type) {
    case FETCH_KPI_FORECASTS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: true,
          error: false,
        },
      };
    case FETCH_KPI_FORECASTS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
        },
        data: action.data,
      };
    case FETCH_KPI_FORECASTS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
          error: true,
        },
      };
    case SELECT_KPI_FORECAST:
      return {
        ...state,
        data: {
          ...state.data,
          active: action.forecast,
        },
      };
    default:
      return state;
  }
};

const currentForecast = (state = defaultState.currentForecast, action) => {
  switch (action.type) {
    case FETCH_CURRENT_KPI_FORECAST_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: true,
          error: false,
        },
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    case FETCH_CURRENT_KPI_FORECAST_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
        },
        filters: {
          ...state.filters,
          ...action.filters,
        },
        data: action.data,
      };
    case FETCH_CURRENT_KPI_FORECAST_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: false,
          error: true,
        },
        filters: action.filters,
      };
    default:
      return state;
  }
};

export default combineReducers({
  currentPage,
  marketReports,
  researchLibrary,
  customExports,
  customReports,
  versionHistory,
  forecasts,
  currentForecast,
});
